// extracted by mini-css-extract-plugin
export default {"link":"SQLhy","selected":"lr4Bz","icon":"zOdHt"};